import React from "react";
import { connect } from "react-redux";
import ChatSelectorRender from "./render.js"

function ChatSelector(props) {
  //console.log("props :", props)
  let list = props.chats;
  const labelPath = props.labelPath + ".chatSelector"
  return (
    <ChatSelectorRender labelPath={labelPath} list={list} action={props.makeVisible} />
  );
}

export default connect(state => ({
  lang: state.locale.lang
}))(ChatSelector);
